import moment from 'moment';

export function request(id, name, conditions) {
    id = parseInt(id, 10);

    if (conditions && conditions.startDate) {
        conditions.startDate = moment(conditions.startDate).format('YYYY-MM-DDT00:00:00');
    }

    if (conditions && conditions.endDate) {
        conditions.endDate = moment(conditions.endDate).format('YYYY-MM-DDT23:59:59');
    }

    return {
        type: 'CUSTOMERS_GET_TRANSACTIONS_REQUEST',
        id,
        name,
        conditions
    };
}

export function error(id, name, errors) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_GET_TRANSACTIONS_ERROR',
        errors,
        name,
        id
    };
}

export function finish(id, name, transactions) {
    let assetFlows = {};

    for (let transaction of transactions) {
        assetFlows[transaction.id] = (assetFlows[transaction.id] || []).concat(transaction.assetFlows);
    }

    let existentTransactions = {};
    let uniqueTransactions = [];

    for (let transaction of transactions) {
        if (!existentTransactions[transaction.id]) {
            existentTransactions[transaction.id] = true;
            transaction.assetFlows = assetFlows[transaction.id];
            uniqueTransactions.push(transaction);
        }
    }

    return {
        type: 'CUSTOMERS_GET_TRANSACTIONS_FINISH',
        transactions: uniqueTransactions,
        name,
        id
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_GET_TRANSACTIONS_CLEAR'
    };
}
